import React, { useEffect } from 'react'
import AppleIcon from '@mui/icons-material/Apple';
import SportsGymnasticsIcon from '@mui/icons-material/SportsGymnastics';
import { Link } from 'react-router-dom';
import EditNoteIcon from '@mui/icons-material/EditNote';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { Removefun, check_token } from '../Redux/Allslice';
import { toast } from 'react-toastify';
const Navbar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
      setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
      setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
      setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
      setAnchorElUser(null);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClose = () => {
      setAnchorEl(null);
  }

  const dispatch = useDispatch()
  
  const {loading,LogoutToggle}= useSelector((state)=>state?.logininstore)
  console.log("tgg",LogoutToggle);
 
  const name = localStorage.getItem("Name")
  // console.log("my",name);
  const logout =()=>{
      dispatch(Removefun())
      toast.success("Logged out successfully")
  }
  useEffect(()=>{
   dispatch(check_token())
  },[])
  return (

    <>
     <AppBar position='sticky' style={{ backgroundColor: "#FAD90B" }}>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <SportsGymnasticsIcon size='large' color='inherit' edge='start' aria-label='logo' sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
                        <Typography
                            variant="h6"
                            noWrap
                            component="a"
                            href="#app-bar-with-responsive-menu"
                            sx={{
                                flexGrow: 1,
                                mr: 2,
                                display: { xs: 'none', md: 'flex' },
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                        >
                            GYM
                        </Typography>
                        {LogoutToggle?
                            (<>
                                <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
                                    <IconButton
                                        size="large"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        onClick={handleOpenNavMenu}
                                        color="inherit"
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                    <Menu
                                        id="menu-appbar"
                                        anchorEl={anchorElNav}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        open={Boolean(anchorElNav)}
                                        onClose={handleCloseNavMenu}
                                        sx={{
                                            flexGrow: 1,
                                            display: { xs: 'block', md: 'none' },
                                        }}
                                    >

                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Typography textAlign="center"><Link to='/' style={{textDecoration:"none", color:"black"}}>Home</Link></Typography>
                                        </MenuItem>
                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Typography textAlign="center"><Link to='/service' style={{textDecoration:"none", color:"black"}}>Service</Link></Typography>
                                        </MenuItem>
                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Typography textAlign="center"><Link to='/blog' style={{textDecoration:"none", color:"black"}}>Blog</Link></Typography>
                                        </MenuItem>
                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Typography textAlign="center"><Link to='/dashboard' style={{textDecoration:"none", color:"black"}}>{name}</Link></Typography>
                                        </MenuItem>
                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Typography textAlign="center" onClick={() => { handleClose(); logout() }}>Logout</Typography>
                                        </MenuItem>
                                    </Menu>
                                </Box>
                                <SportsGymnasticsIcon size='large' color='inherit' edge='start' aria-label='logo' sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' }, mr: 1 }} />
                                <Typography
                                    variant="h5"
                                    noWrap
                                    component="a"
                                    href="#app-bar-with-responsive-menu"
                                    sx={{
                                        mr: 2,
                                        display: { xs: 'flex', md: 'none' },
                                        flexGrow: 1,
                                        fontFamily: 'monospace',
                                        fontWeight: 700,
                                        letterSpacing: '.3rem',
                                        color: 'inherit',
                                        textDecoration: 'none',
                                    }}
                                >
                                    GYM
                                </Typography>
                                <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, color: 'white' }}
                                    >
                                        <Link to='/' style={{textDecoration:"none", color:"white"}}>Home</Link>
                                    </Button>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, color: 'white' }}
                                    >
                                       <Link to='/service' style={{textDecoration:"none", color:"white"}}>Service</Link>
                                    </Button>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, color: 'white' }}
                                    >
                                       <Link to='/blog' style={{textDecoration:"none", color:"white"}}>Blog</Link>
                                    </Button>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, color: 'white' }}
                                    >
                                        <Link to='/dashboard' style={{textDecoration:"none", color:"white"}}>{name}</Link>
                                    </Button>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, color: 'white' }}
                                    >
                                        <Link to='/dashboard' style={{textDecoration:"none", color:"white"}} onClick={() => { handleClose(); logout() }}>Logout</Link>
                                    </Button>
                                </Box>
                                <Box sx={{ flexGrow: 0 }}>
                                    <Menu
                                        sx={{ mt: '45px' }}
                                        id="menu-appbar"
                                        anchorEl={anchorElUser}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchorElUser)}
                                        onClose={handleCloseUserMenu}
                                    >
                                            <MenuItem onClick={handleCloseUserMenu}>
                                                <Typography textAlign="center" onClick={() => { handleClose(); logout() }}>Logout</Typography>
                                            </MenuItem>
                                    </Menu>
                                </Box>
                            </>)
                            :
                            (<>
                                <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
                                    <IconButton
                                        size="large"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        onClick={handleOpenNavMenu}
                                        color="inherit"
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                    <Menu
                                        id="menu-appbar"
                                        anchorEl={anchorElNav}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        open={Boolean(anchorElNav)}
                                        onClose={handleCloseNavMenu}
                                        sx={{
                                            flexGrow: 1,
                                            display: { xs: 'block', md: 'none' },
                                        }}
                                    >

                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Typography textAlign="center"><Link to='/' style={{ textDecoration: 'none', color: "black" }}>Home</Link></Typography>
                                        </MenuItem>
                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Typography textAlign="center"><Link to='/service' style={{textDecoration:"none", color:"black"}}>Service</Link></Typography>
                                        </MenuItem>
                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Typography textAlign="center"><Link to='/blog' style={{textDecoration:"none", color:"black"}}>Blog</Link></Typography>
                                        </MenuItem>
                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Typography textAlign="center"><Link to='/signin' style={{ textDecoration: 'none', color: "black" }}>login</Link></Typography>
                                        </MenuItem>
                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Typography textAlign="center"> <Link to='/register' style={{textDecoration:"none", color:"black"}}>Register</Link></Typography>
                                        </MenuItem>

                                    </Menu>
                                </Box>
                                <SportsGymnasticsIcon size='large' color='inherit' edge='start' aria-label='logo' sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' }, mr: 1 }} />
                                <Typography
                                    variant="h5"
                                    noWrap
                                    component="a"
                                    href="#app-bar-with-responsive-menu"
                                    sx={{
                                        mr: 2,
                                        display: { xs: 'flex', md: 'none' },
                                        flexGrow: 1,
                                        fontFamily: 'monospace',
                                        fontWeight: 700,
                                        letterSpacing: '.3rem',
                                        color: 'inherit',
                                        textDecoration: 'none',
                                    }}
                                >
                                    GYM
                                </Typography>
                                <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, color: 'white' }}
                                    >
                                        <Link to='/' style={{textDecoration:"none", color:"white"}}>Home</Link>
                                    </Button>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, color: 'white' }}
                                    >
                                        <Link to='/service' style={{textDecoration:"none", color:"white"}}>Service</Link>
                                    </Button>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, color: 'white' }}
                                    >
                                        <Link to='/blog' style={{textDecoration:"none", color:"white"}}>Blog</Link>
                                    </Button>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, color: 'white' }}
                                    >
                                        <Link to='/signin' style={{textDecoration:"none", color:"white"}}>Login</Link>
                                    </Button>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{ my: 2, color: 'white' }}
                                    >
                                        <Link to='/register' style={{textDecoration:"none", color:"white"}}>Register</Link>
                                    </Button>

                                </Box>
                            </>)}
                        </Toolbar>
                </Container>
            </AppBar>
    </>
  )
}

export default Navbar;
